import { ConfigService } from './config-service';

export class NextApiService {
  private apiUrl: string = ConfigService.cmsApiUrl || 'https://smartbuyuat.reward360.in/v2/api/trpc';

  private async request(method: string, url: string, body?: any, headers?: any) {
    const options: RequestInit = {
      method,
      headers: {
        'Content-Type': 'application/json',
        ...headers
      }
    };
    if (body) {
      options.body = JSON.stringify(body);
    }

    try {
      const response = await fetch(`${this.apiUrl}${url}`, options);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const result = await response.json();
      if (result[0]?.result?.data?.json) return result[0].result.data.json;
      else return {};
    } catch (error) {
      throw new Error(`API request failed: ${error.message}`);
    }
  }

  public async get(url: string, headers?: any) {
    return this.request('GET', url, undefined, headers);
  }

  public async post(url: string, body: any, headers?: any) {
    return this.request('POST', url, body, headers);
  }

  public async put(url: string, body: any, headers?: any) {
    return this.request('PUT', url, body, headers);
  }

  public async delete(url: string, headers?: any) {
    return this.request('DELETE', url, undefined, headers);
  }
}
